export default __webpack_public_path__ + "static/client2-3c4e915b17cb083e684eb4e5a90556cb.png";